import {
  GET_WORK_ITEM_ALERTS_FETCH_ERROR,
  GET_WORK_ITEM_ALERTS_FETCH_START,
  GET_WORK_ITEM_ALERTS_FETCH_SUCCESS,
} from "../reducers/WorkItemAlertsReducer";
import {
  getTasks,
  METRICS_ALERT,
  WIVS_TASK_STATUSES,
} from "../../../network/WIVSNetwork";
import { getStationCode } from "../../../network/NetworkUtil";

/**
 * Parse roles from raw string, handling both JSON arrays and single strings
 * @param {string} rolesRaw - Raw roles string from task attributes
 * @returns {Array} Parsed roles array
 */
const parseRoles = (rolesRaw) => {
  if (!rolesRaw) return [];
  try {
    return JSON.parse(rolesRaw);
  } catch (e) {
    return [rolesRaw];
  }
};

/**
 * Get all work item alerts
 */
export function fetchWorkItemAlerts() {
  return async (dispatch) => {
    dispatch({ type: GET_WORK_ITEM_ALERTS_FETCH_START });

    try {
      const stationCode = getStationCode();
      const tasksResponse = await getTasks(stationCode);

      const filteredAlerts = tasksResponse.data.tasks
        .filter(
          (task) =>
            task.name.includes(METRICS_ALERT) &&
            [WIVS_TASK_STATUSES.STARTED, WIVS_TASK_STATUSES.ACTIVE].includes(
              task.status,
            ),
        )
        .map((task) => ({
          ...task,
          metricName:
            task.additionalAttributes &&
            task.additionalAttributes.METRIC_NAME &&
            task.additionalAttributes.METRIC_NAME.attributeValue,
          roles: parseRoles(
            task.additionalAttributes &&
              task.additionalAttributes.ROLES &&
              task.additionalAttributes.ROLES.attributeValue,
          ),
        }));

      dispatch({
        type: GET_WORK_ITEM_ALERTS_FETCH_SUCCESS,
        payload: filteredAlerts,
      });
    } catch (err) {
      dispatch({
        type: GET_WORK_ITEM_ALERTS_FETCH_ERROR,
        error: err.message,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/mySCC/common/thunks/WorkItemAlertsDispatcher.js